import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Modal } from "semantic-ui-react";
import PropTypes from "prop-types";

import AssignVoicemailForm from "./AssignVoicemailForm";

const AssignVoicemailModal = forwardRef(({ onSuccess }, ref) => {
  const [open, setOpen] = useState(false);
  const [twilioPhoneNumberId, setTwilioPhoneNumberId] = useState();
  const [voicemailId, setVoicemailId] = useState();

  useImperativeHandle(ref, () => ({
    open: handleOpen,
  }));

  const handleOpen = (twilioPhoneNumberId, voicemailId) => {
    setTwilioPhoneNumberId(twilioPhoneNumberId);
    setVoicemailId(voicemailId);
    setOpen(true);
  };

  const handleSuccess = () => {
    onSuccess();
    setOpen(false);
  };

  return (
    <Modal
      size="large"
      open={open}
      onClose={() => setOpen(false)}
      closeOnDimmerClick={false}
      onFocus={e => e.stopPropagation()}
      onClick={e => e.stopPropagation()}
      closeIcon
    >
      <Modal.Header>Assign Voicemail</Modal.Header>
      <Modal.Content>
        <AssignVoicemailForm
          twilioPhoneNumberId={twilioPhoneNumberId}
          voicemailId={voicemailId}
          onSuccess={handleSuccess}
        />
      </Modal.Content>
    </Modal>
  );
});

AssignVoicemailModal.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default AssignVoicemailModal;
